<template>
  <main-farme>
    <div slot="main">
      <!-- ----------------------------------------遍历 数据---------------------------------------- -->
      <div style="background-color:#fff;padding:20px">
        <div v-for="item,index in data_list"
             ref="htem_list"
             :key="index">
          <!-- 基本数据: 点击，返回数据 更新 地图 -->
          <div class="block_plan_item"
               @click="selectTransitPlan(item,index)">
            <div>
              方案:{{index+1}}
              <el-tag style="float:right"
                      v-for="item,index in item.tags"
                      :key="index"
                      size="mini">
                <span v-if="item=='LEAST_TRANSFER'">少换乘</span>
                <span v-if="item=='LEAST_TIM'">时间短</span>
                <span v-if="item=='LEAST_WALKING'">少步行</span>
              </el-tag>
            </div>
            <span>距离： {{(item.distance/1000).toFixed(1)}} 公里; 时间：{{item.duration_1m}}分钟。</span>
          </div>
          <!-- 详细数据：默认隐藏 -->
          <div v-if="activeDetail === index "
               class="block_plan_item_detail">
            <div v-for="step_item,index in item.steps"
                 :key="index">
              <!-- ----------------------------------------------步行方案------------------------------------------ -->
              <div v-if="step_item.mode == 'WALKING'">
                🚶‍♀️{{step_item.mode}}
                <p>步行约： {{(step_item.distance/1000).toFixed(2)}}公里,{{step_item.duration}}分钟</p>
              </div>
              <!-- ----------------------------------------------公共交通------------------------------------------ -->
              <div v-else-if="step_item.mode == 'TRANSIT'">
                <!-- 交通工具和路线：地铁 -->
                <div v-if="step_item.lines[0].vehicle=='SUBWAY'">
                  🚊 {{step_item.lines[0].vehicle}}
                  <!-- 交通描述: 进站、方向、几号口 -->
                  <p>乘 📍{{step_item.lines[0].title}}({{step_item.lines[0].destination.title}}方向)
                    <span v-if="'exit' in step_item.lines[0].geton"> {{step_item.lines[0].geton.exit.title}}入</span>
                  </p>
                  <p> 到 {{step_item.lines[0].getoff.title}}
                    <!-- 出站 -->
                    <span v-if="'exit' in step_item.lines[0].getoff"> {{step_item.lines[0].getoff.exit.title}}出</span>
                  </p>

                </div>
                <!-- 交通工具和路线：火车 -->
                <div v-if="step_item.lines[0].vehicle=='RAIL'">{{step_item.lines[0].vehicle}}</div>
                <!-- 交通工具和路线：公共汽车 -->
                <div v-if="step_item.lines[0].vehicle=='BUS'">{{step_item.lines[0].vehicle}}</div>
              </div>
            </div>
            <el-button style="width:100%;margin-top:10px"
                       size="mini"
                       @click="addContentToEditor(item,index)">选择</el-button>
          </div>
        </div>

      </div>
      <!-- ----------------------------------------编辑器---------------------------------------- -->
      <div style="background-color:#fff;padding:20px;margin-top: 50px">
        <editor-mini :editor_content="editor_content"
                     @onEditorChange="onEditorChange"></editor-mini>
      </div>

      <!--  -->
    </div>
  </main-farme>

</template>

<script>
import MainFrame from '../main/MainFrame'
import EditorV2 from '..//editor/editorV2mini'

export default {
  components: {
    'main-farme': MainFrame,
    'editor-mini': EditorV2,
  },
  data() {
    return {
      editor_content: '',
      data_list: [],
      activeDetail: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onEditorChange(val) {},
    addContentToEditor(item, index) {
      const element = this.$refs.htem_list[index]

      const ser = new XMLSerializer()
      const str = ser.serializeToString(element)
      console.log('str', str)

      // const reg = /<\/?.+?\/?>/g
      // const val = str.replace(reg, '')
      console.log('val', val)
      this.editor_content = str

      // console.log(
      //   this.$refs.htem_list[index]
      //     .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
      //     .replace(/<[^>]+?>/g, '')
      //     .replace(/\s+/g, ' ')
      //     .replace(/ /g, ' ')
      //     .replace(/>/g, ' ')
      // )
    },
    selectTransitPlan(item, index) {
      if (this.activeDetail == index) {
        this.activeDetail = null
      } else {
        this.activeDetail = index
      }
    },
    // 标签转文本
    ToText(HTML) {
      let input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    // -------------------
    getData() {
      this.$http
        .get(
          `/traver/api_map_qq_routes_transit?from_lat=32.044228&from_lng=118.797444&to_lat=31.730301994&to_lng=118.876018305&route_mode=transit`
        )
        .then((res) => {
          this.data_list = res.data.data
        })
    },
  },
}
</script>

<style >
p {
  margin: 20px;
}

.block_plan_item {
  background-color: lightgray;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
}
.block_plan_item_detail {
  margin: 5px;
  padding: 10px;
}
</style>


